export const version = '9.4.5-treelab'
// Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.
